<template>
  <div class="ps-tab-group ps-flex">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TabGroup',
  props: {
    msg: String
  }
}
</script>
